module.exports = __webpack_public_path__ + "images/home/product/features-kanban-6b3e82fec2e58ed32b555398ee8de33e.png";